<template>
 <!-- ================ contact section start ================= -->
  <section class="section-margin">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-lg-3 mb-4 mb-md-0">
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-home"></i></span>
            <div class="media-body">
              <h3>Stockholm, Sweden</h3>
              <p>Hälsingegatan 51, 113 66.</p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-headphone"></i></span>
            <div class="media-body">
              <h3><a href="tel:+46855109280">+46 8 551 092 80</a></h3>
              <p>Mon to Fri 8am to 6pm</p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-email"></i></span>
            <div class="media-body">
              <h3><a href="mailto:taieb@retainerdesk">taieb@retainerdesk.com</a></h3>
              <p>Send us your query anytime!</p>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-9">
          <h3>Ready to get in touch with RetainerDesk?</h3>
Enter your email or phone number and we will be in touch shortly!
          <div class="form-contact contact_form" id="contactForm" >
            <div class="row">
              <div class="col-lg-7">
                  <br><br>
                <div class="form-group">
                  <input v-model="email" class="form-control" name="email" id="email" type="email" placeholder="Enter email or phone">
                </div>
              </div>

            </div>
            <div class="form-group text-center  mt-3">
              <button type="submit" @click="sendMail()" :disabled="valid" class="button button-contactForm">Send your details</button>
            </div>
            <div v-if="valid">Thanks! We will come back to you soon!</div>

          </div>
        </div>
        <div class="row" style="display:none;">
          <div class="col-xs-12">
              <button type="submit" class="button button-contactForm" onclick="location.href='https://app.retainerdesk.com/#/motivators?q=137b6433-a35d-4890-9fb3-a6ae7dc4016d&ce=mahammad@mensa.com'">Cancel subscription</button>
          </div>
        </div>
      </div>
    </div>
  </section>
	<!-- ================ contact section end ================= -->
</template>

<script>
export default {
	data() {
		return {
			email: '',
      valid: false,
      message: ''
		}
	},
	methods: {
		sendMail() {

			const obj = {
				from: this.email,
				to: 'info@retainerdesk.com'
			}

			if(this.email.length < 3) {
				alert("Your email need to be valid");
				return;
      }

			this.$store.dispatch('SEND_MAIL', obj);
      this.valid = true;
      gtag_report_conversion()
		}
	}

}
</script>